<template>
    <div class="banner bng-casino-banner-fish">
        <img
            :src="isMobilePhone ? '/static/banners/casino-home-banner/mobile/fish.jpg' : '/static/banners/casino-home-banner/desktop/fish.jpg'"
        />
        <div class="content">
            <div>
                <div>
                    <b>{{"components.common.banners.casino-banners.fish.msg1" | translate}}</b>
                    <span>{{"components.common.banners.casino-banners.fish.msg2" | translate}}</span>
                </div>
            </div>
        </div>
        <div class="detailed">
            <router-link :to="{ name: 'slot-game-redpipe', params: { game: 'fu-fish' } }">{{"components.common.banners.casino-banners.fish.play" | translate}}</router-link>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'casino-banner-fish',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        },
        percent() {
            return this.client && this.client.bonus.cashback && this.client.bonus.cashback.percent;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/casino-banners/fish.vue